import { useEffect, useState } from "react";
import "./index.css";
import Lenis from "@studio-freight/lenis";
import Hero from "./Hero";
import About from "./About";
import HowItWorks from "./HowItWorks";
import Services from "./Services";
import Benefits from "./Benefits";
import Testimonials from "./Testimonials";
import Partners from "./Partners";
import FAQ from "./FAQ";
import Contact from "./Contact";
import Footer from "./Footer";
import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./Theme/theme";
import Header from "./Header";
import { getUsers } from "../../utils/getUser";
import { useNavigate } from "react-router-dom";
import CustomLoader from "../../components/CustomLoader";
import Comparison from "./Comparision";

export default function LandingPage() {
  const [showLoader, setShowLoader] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: "vertical",
      gestureDirection: "vertical",
      smooth: true,
      smoothTouch: false,
      touchMultiplier: 2,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    setShowLoader(true);
    const user = getUsers();
    if (!user) {
      setShowLoader(false);
      return;
    }

    // Check if 2FA setup is pending
    if (user?.requires_2fa_action === "setup") {
      setShowLoader(false);
      navigate("/setup-2fa", { state: { userData: user } });
      return;
    }

    // Check if 2FA verification is pending
    if (user?.requires_2fa_action === "verify") {
      setShowLoader(false);
      navigate("/login");
      return;
    }

    if (user?.is_verified) {
      if (user?.role === "MEMBER") {
        setShowLoader(false);
        navigate("/user-dashboard");
      } else if (user?.role === "MANAGER") {
        setShowLoader(false);
        navigate("/manager-dashboard");
      } else if (user?.role === "SUPERADMIN") {
        setShowLoader(false);
        navigate("/admin-dashboard");
      } else if (user?.role === "VENDOR") {
        setShowLoader(false);
        navigate("/dashboard/gift-cards");
      } else {
        return;
      }
    } else {
      setShowLoader(false);
      sessionStorage.setItem("activeStep", 5);
      navigate("/signup", {
        state: {
          isVerifiedCheck: true,
          email: user?.email,
        },
      });
    }
  }, []);

  return (
    <>
      <CustomLoader open={showLoader} />
      <CssBaseline />
      <ThemeProvider theme={theme}>
        <Box sx={{ bgcolor: "black", minHeight: "100vh" }}>
          <Header />
          <Hero />
          <About />
          <HowItWorks />
          <Services />
          <Benefits />
          <Comparison />
          <FAQ />
          <Contact />
          <Footer />
        </Box>
      </ThemeProvider>
    </>
  );
}
